/**
 * Event Library
 *
 * Throws global events for initializing your javascript code:
 *
 * Events:
 *  - TechDivision.Event.initialize:    Gets called whenever an entire page got rendered in backend and frontend
 *  - TechDivision.Event.nodeAdded:     Gets called when a node got added in backend
 *  - TechDivision.Event.apiInitialized The api of currently google got initialized(gets only triggered if a map is on the current dom
 *
 * @module Event
 */
(function Event(){

    var apiAdded = false;

    function ready(fn) {
        if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading"){
            fn();
        } else {
            document.addEventListener('DOMContentLoaded', fn);
        }
    }

    /**
     * Event: TechDivision.Event.initialize
     */
    function initialize() {
        if (typeof CustomEvent === 'function') {
            document.dispatchEvent(new CustomEvent("TechDivision.Event.initialize"));
        } else if (typeof document.createEvent === 'function') {
            /* older browsers need this to create, init and dispatch the event */
            var event = document.createEvent('CustomEvent');
            event.initCustomEvent("TechDivision.Event.initialize", true, true, {});
            document.dispatchEvent(event);
        }
    }

    if (typeof document.addEventListener === 'function') {
        document.addEventListener('Neos.PageLoaded', function(event) {
            initialize();
        }, false);

        /**
         * Event: TechDivision.Event.nodeAdded
         */
        document.addEventListener('Neos.NodeCreated', function(event) {
            document.dispatchEvent(new CustomEvent("TechDivision.Event.nodeAdded", { detail: event.detail.element }));
        }, false);
    }
    ready(initialize);
})();